// Only these keys are eligible to be edited per cma
export const whitelistTemplateKeys = ["cover_letter"];
